export const TEXT = 'TEXT';
export const BOOL = 'BOOL';
